import React, { useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import Send from "../../../../../../images/Send.svg";
import ConfirmationImage from "../../../../../../images/Confirmation.svg";
import Success from "../../../../../../images/Successfully_Sent_mail_GIF.gif";
import { confirmationType } from "../List";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<confirmationType>>;
  handleSendMail: () => Promise<void>;
}

const Confirmation = ({ setModalFlag, handleSendMail }: Props) => {
  const [success, setSuccess] = useState(false);

  return (
    <>
      <div className="quotation__confirmation">
        {!success ? (
          <>
            <img
              src={ConfirmationImage}
              alt=""
              className="quotation__confirmation--image"
            />
            <Title>Confirmation</Title>
            <div className="quotation__confirmation--text">
              Are you sure you want to continue to send mail to all the
              suppliers for quotation
            </div>
            <div className="quotation__confirmation--buttons">
              <button
                className="quotation__confirmation--buttons--send"
                onClick={() => handleSendMail()}
              >
                <img src={Send} alt="" /> Send mail for quotation
              </button>
              <button
                className="quotation__confirmation--buttons--cancel"
                onClick={() => {
                  setModalFlag({
                    flag: false,
                    rfqId: 0,
                  });
                }}
              >
                <img src={Close} alt="" />
                Cancel
              </button>
            </div>{" "}
          </>
        ) : (
          <>
            <Title> Successfully sent mail</Title>

            <img src={Success} alt="" className="loading-gif" />
            <div className="quotation__confirmation--buttons">
              <button className="quotation__confirmation--buttons--cancel">
                <img
                  src={Close}
                  alt=""
                  onClick={() =>
                    setModalFlag({
                      flag: false,
                      rfqId: 0,
                    })
                  }
                />
                Cancel
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Confirmation;
